import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchChangeEmail } from '../../../api';

export const securityAuthenticationChangeEmailAsyncSlice = createPatchAsyncSlice({
	name: 'SecurityAuthenticationChangeEmail',
	receive: false,
	request: true,
	requestHandler: patchChangeEmail
});
